import { Settings } from "lucide-react";
import { type FC } from "react";

// eslint-disable-next-line boundaries/element-types -- Reason: Navigation tree is infrastructure utility, not domain-specific. This is a shared dependency for workspace apps.
import { navTree } from "@/app/navigation/navTree";
import { IntermediatePage } from "@/components/organisms/IntermediatePage";

/**
 * **AdminPanelApp**
 *
 * Admin Panel workspace with automated card generation
 * based on the navigation tree structure.
 *
 * @returns AdminPanelApp component
 *
 */
export const AdminPanelApp: FC = () => {
  // Find the admin panel node in the navigation tree
  const adminNode = navTree.children?.find((child) => child.id === "admin-panel");

  if (!adminNode) {
    return (
      <div className="min-h-screen bg-background p-6">
        <h1 className="text-2xl font-bold">Admin Panel</h1>
        <p className="text-neutral-400">Admin panel configuration not found.</p>
      </div>
    );
  }

  return (
    <IntermediatePage
      description="System administration and management tools"
      headerGradient={{ from: "from-orange-500", to: "to-orange-600" }}
      icon={<Settings className="w-6 h-6 text-white" />}
      navNode={adminNode}
      title="Admin Panel"
    />
  );
};
